<template>
  <div >
    <div class="onBoardRegistration padd" id="registration">
      
      <div v-if="showToastError">
        <div
          style="
            margin-bottom: 25px;
            padding: 20px;
            background-color: #ef5451;
            border-radius: 20px;
            color: white;
            display: -webkit-flex;
            display: flex;
            align-items: center;
          "
        >
          <span class="warpit_icon_alert" style="font-size: 32px; margin-right: 15px"></span>
          {{ showToastMessage }}
        </div>
      </div>

      <form action="#" class="custom-form"
        v-on:submit.prevent="onSubmit"
        >
                
        <div class="form-group" v-bind:class="{ 'not-empty': !isEmailEmpty }">
          <input
            type="text"
            class="form-control"
            name="email"
            id="email"
            v-model="form.email"
            v-on:keypress="formUtilsValidateInputEmptySpaces($event)"
            required
            @blur="formUtilsCheckEmail()"
          />
          <label for="email" class="animated-label">{{ $t("login.email") }}</label>
          <span class="line"></span>
        </div>

         
        <span class="errorSexTxt" v-if="errors.maxCharacter" for="email">{{ $t("error.max_email_character") }}</span>
        <span class="errorSexTxt" v-if="errors.email" for="email">{{ $t("error.email_missing") }}</span>

        <div class="form-group" v-bind:class="{ 'not-empty': !isPasswordEmpty }">
          <input
            v-bind:type="passwordType"
            class="form-control"
            name="pass"
            id="pass"
            v-model="form.password"
            required
            @blur="formUtilsCheckPasswordSave()"
            @paste="formUtilsOnPaste($event)"
          />
          <label for="pass" class="animated-label">{{ $t("login.password") }}</label>
          <span
            class="icon passVisible"
            v-bind:class="{
              warpit_icon_eye: isPasswordEyeSlashClass,
              'warpit_icon_eye-slash': !isPasswordEyeSlashClass,
            }"
            v-on:click.prevent="formUtilsShowPassword()"
          ></span>
          <span class="line"></span>
        </div>

        <span
          class="errorSexTxt"
          v-if="errors.password"
          for="password"
        >{{ $t("error.invalid_password") }}</span>
        

        <div class="form-group" v-bind:class="{ 'not-empty': !isPasswordConfirmationEmpty }">
          <input
            v-bind:type="passwordConfirmationType"
            class="form-control"
            name="passAg"
            id="passAg"
            v-model="form.passwordConfirmation"
            required
            @blur="formUtilsCheckPasswordConfirmation()"
            @paste="formUtilsonPasteConfirm()"
          />
          <label for="passAg" class="animated-label">{{ $t("login.confirmpassword") }}</label>
          <span
            class="icon passVisible"
            v-bind:class="{
              warpit_icon_eye: isConfirmationPasswordEyeSlashClass,
              'warpit_icon_eye-slash': !isConfirmationPasswordEyeSlashClass,
            }"
            v-on:click.prevent="formUtilsShowConfirmationPassword()"
          ></span>
          <span class="line"></span>
        </div>

        <span
          class="errorSexTxt"
          v-if="errors.passwordConfirmation"
          for="password"
        >{{ $t("error.passwords_do_not_match") }}</span>
        

        <div class="agreeToggle flex">
          <label class="switch">
            <input type="checkbox" name="termAndCondition" id="termAndCondition" v-on:click="formUtilsTermAndCondition()" />
            <span class="slider round"></span>
          </label>
          <div class="agreeToggleDesc">
            <span>
              {{ $t("login.term_text_1") }}
              <a class="txt" href="/terms-and-conditions">{{ $t("login.term_text_2") }}</a>
            </span>
            <span class="tajni">
              {{ $t("login.term_desc_1") }}
              <a class="txt" href="/privacy-policy">{{ $t("login.term_desc_2") }}</a>.
            </span>
          </div>
        </div>

        <span
          class="errorSexTxt"
          v-if="errors.termsAndConditionsCheckbox === true"
        >{{ $t("error.terms_not_selected") }}</span>
        
        <div class="next flex">
          <a
            class="join smallFont hoverEffect"
            ref="registerButton"
            v-on:mouseover="formUtilsMouseHoverEffect($event, 'registerButton')"
            v-on:mouseout="formUtilsMouseHoverEffect($event, 'registerButton')"
            v-on:click.prevent="onSubmit()"
            href="javascript:void(0);"
          >
            <label>{{ $t("login.next_step")}}</label>
            <span
              class="effect"
              ref="effectRegisterButton"
              v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
            ></span>
            <img src="@/assets/images/nextArrowAnimation.svg" />
          </a>
        </div>
        
      </form>
    </div>
  </div>
</template>
<script>

import { 
  formUtilsCheckEmail, 
  formUtilsCheckPasswordSave, 
  formUtilsCheckPasswordConfirmation, 
  formUtilsMouseHoverEffect, 
  formUtilsShowPassword,
  formUtilsShowConfirmationPassword,
  formUtilsCheckAnimation,
  formUtilsValidateInputEmptySpaces,
  formUtilsOnPaste,
  formUtilsonPasteConfirm,
  formUtilsCheckTermsAndCondition,
  formUtilsTermAndCondition
} from '@/utils/form_utils.js';

export default {
  data() {
    return {
      showToastError: false,
      showToastMessage: "",
      isPasswordEyeSlashClass: true,
      isConfirmationPasswordEyeSlashClass: true,
      passwordType: "password",
      passwordConfirmationType: "password",
      termsAndConditionsCheckbox: false,
      isPasswordEmpty: true,
      isEmailEmpty: true,
      isPasswordConfirmationEmpty: true,

      form: {
        email: "",
        name: "not defined",
        surname: "not defined",
        dateOfBirth: null,
        sex: 0,
        password: "",
        passwordConfirmation: "",
        recruitToken: localStorage.recruitToken,
        rtp: 1,
        recaptchaToken: "",
      },

      errors: {
        maxCharacter: false,
        email: false,
        password: false,
        passwordConfirmation: false,
        termsAndConditionsCheckbox: false,
      },

      topX: 1,
      leftX: 1
    };
  },
  mounted() {

    this.$initRecaptcha();

    const rtp = this.$cookie.get('rtp');
    if(rtp) {
      try {
        this.form.rtp = parseInt(rtp);
      }
      catch(err) {
        console.error(err);
      }
    }
  },
  methods: {
    formUtilsShowPassword,
    formUtilsShowConfirmationPassword,
    formUtilsCheckPasswordConfirmation,
    formUtilsMouseHoverEffect,
    formUtilsCheckEmail,
    formUtilsCheckAnimation,
    formUtilsValidateInputEmptySpaces,
    formUtilsOnPaste,
    formUtilsonPasteConfirm,
    formUtilsCheckPasswordSave,
    formUtilsCheckTermsAndCondition,
    formUtilsTermAndCondition,

    onSubmit() {
      /* CHECK FIELDS BEFORE SUBMIT */
      this.formUtilsCheckEmail();
      if (this.errors.email === true) {
        return;
      }
      this.formUtilsCheckPasswordSave();

      this.formUtilsCheckPasswordConfirmation();
      if (this.errors.passwordConfirmation === true) {
        return;
      }
      this.formUtilsCheckTermsAndCondition();
      if (this.errors.termsAndConditionsCheckbox === true) {
        return;
      }

      /* CHECK CAPTCHA */
      this.$checkRecaptcha().then((token) => {
        this.sendForm(token);
      }).catch((error) => {
        console.error("Error reCAPTCHA:", error);
      });
    },

    sendForm(recaptchaToken) {
      this.form.recaptchaToken = recaptchaToken;

      this.$http
        .post("api/v2/register", this.form)
        .then(() => {
          localStorage.removeItem("recruitToken");
          this.$cookie.set('verification_accept', true, { expires: '1h' });
          this.$cookie.set('verification_email',  this.form.email, { expires: '1h' });
          this.$router.push({
            name: "verification",
          });
        })
        .catch((error) => {
          if (typeof error.body.message === "undefined") {
            this.showToastMessage = this.$t("error.invalid_registration");
            this.showToastError = true;

            return;
          }
          if (JSON.parse(error.body.message).user) {
            this.showToastMessage = this.$t("error.user_exists");
            this.showToastError = true;

            return;
          }
          return;
        });
    },

  },
};
</script>
<style>
.swal2-popup .swal2-styled.swal2-confirm {
  border: 0;
  border-radius: 1.25em !important;
  background: initial;
  background-color: #0297a7;
  color: #fff;
  font-size: 1.0625em;
}
.swal2-popup #swal2-content {
  text-align: left !important;
}
</style>